import { jsx as d } from "react/jsx-runtime";
import { RadioGroup as n } from "@chakra-ui/react";
import { ThemeSpaceVariable as c } from "../../theme/theme-types.js";
function R({
  children: o,
  name: r,
  isDisabled: i,
  defaultValue: m,
  value: e,
  onChange: p,
  display: a = "flex",
  flexDirection: u = "column",
  gap: t = c.Medium,
  ...f
}) {
  return /* @__PURE__ */ d(
    n,
    {
      name: r,
      isDisabled: i,
      defaultValue: m,
      value: e,
      onChange: p,
      display: a,
      flexDirection: u,
      gap: t,
      ...f,
      children: o
    }
  );
}
export {
  R as RadioGroup
};
